import React from "react"

import Container from "react-bootstrap/Container"
import Tab from "react-bootstrap/Tab"
import Nav from "react-bootstrap/Nav"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"

import pillarStyles from "./pillar.module.css"

import "../components/flaticon/flaticon.css"

import Hexa1 from "../images/hexa1.svg"
import HexaRespect from "../images/hexa_respect.svg"
import HexaExce from "../images/hexa_exce.svg"
import HexaInovation from "../images/hexa_inovation.svg"

const Pillars = () => (
    <Container style={{ paddingTop: "4rem", paddingBottom: "4rem" }} id="core-value">
        <Row className={pillarStyles.values}>
            <Col>
                <h1>Core Values</h1>
            </Col>
        </Row>
        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
            <Row className={pillarStyles.pillar}>
                <Col xs={12}>
                    <Nav variant="pills" className={pillarStyles.nav}>
                        <Nav.Item>
                            <Nav.Link eventKey="first" className={pillarStyles.first}>
                                <i className="flaticon-partner"></i>
                                <p>Partnership</p>
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="second" className={pillarStyles.second}>
                                <i className="flaticon-respect"></i>
                                <p>Respect</p>
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="third" className={pillarStyles.third}>
                                <i className="flaticon-excellency"></i>
                                <p>Excellence</p></Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="fourth" className={pillarStyles.fourth}>
                                <i className="flaticon-creativity"></i>
                                <p>Innovation</p></Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="fifth" className={pillarStyles.fifth}>
                                <i className="flaticon-authentication"></i>
                                <p>Responsibility</p></Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Col>
                <Col xs={12} className={pillarStyles.tabContent}>
                    <Tab.Content style={{marginTop: "5rem"}}>
                        <Tab.Pane eventKey="first">
                            <Row>
                                <Col md={7} className={pillarStyles.fivePillars}>
                                    <div>
                                        <h2>Partnership</h2>
                                        <p>We practice partnership, built upon common goals, open and honest communication, and shared risk and reward.</p>
                                    </div>
                                </Col>
                                <Col md={5}>
                                    <img src={Hexa1} alt="" />
                                </Col>
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane eventKey="second">
                            <Row>
                                <Col md={7} className={pillarStyles.fivePillars}>
                                    <div>
                                        <h2>Respect</h2>
                                        <p>We build mutual trust and respect with respectful, clear, concise, and open communication.</p>
                                    </div>
                                </Col>
                                <Col md={5}>
                                    <img src={HexaRespect} alt="" />
                                </Col>
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane eventKey="third">
                            <Row>
                                <Col md={7} className={pillarStyles.fivePillars}>
                                    <div>
                                        <h2>Excellence</h2>
                                        <p>We strive for excellence in all we do, take pride in our work, and are willing to be held accountable.</p>
                                    </div>
                                </Col>
                                <Col md={5}>
                                    <img src={HexaExce} alt="" />
                                </Col>
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane eventKey="fourth">
                            <Row>
                                <Col md={7} className={pillarStyles.fivePillars}>
                                    <div>
                                        <h2>Innovation</h2>
                                        <p>We encourage and reward innovation, creativity, and bold thinking as we continually enhance our knowledge and client value.</p>
                                    </div>
                                </Col>
                                <Col md={5}>
                                    <img src={HexaInovation} alt="" />
                                </Col>
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane eventKey="fifth">
                            <Row>
                                <Col md={7} className={pillarStyles.fivePillars}>
                                    <div>
                                        <h2>Responsibility & Accountability</h2>
                                        <p>We say what we mean and do what we say. We hold ourselves Personally and corporately Responsible & Accountable to deliver what we Promise.</p>
                                    </div>
                                </Col>
                                <Col md={5}>
                                    <img src={Hexa1} alt="" />
                                </Col>
                            </Row>
                        </Tab.Pane>
                    </Tab.Content>
                </Col>
            </Row>
        </Tab.Container>
    </Container >
)

export default Pillars
